import type { CompliancePolicy } from './compliancePolicy';

export interface AuthParams {
  ottParam?: string | null;
  redirectUrlParam?: string | null;
  roleParam?: string | null;
  businessIdParam?: string | null;
  userIdParam?: string | null;
  compliancePolicyParam?: CompliancePolicy | null;
}

export const buildLoginQueryString = (props: AuthParams): string => {
  const searchParams = new URLSearchParams();

  if (props.ottParam) {
    searchParams.set('ott', props.ottParam);
  }

  if (props.redirectUrlParam) {
    searchParams.set('redirect_url', props.redirectUrlParam);
  }

  if (props.roleParam) {
    searchParams.set('role', props.roleParam);
  }

  if (props.businessIdParam) {
    searchParams.set('business-id', props.businessIdParam);
  }

  if (props.userIdParam) {
    searchParams.set('user-id', props.userIdParam);
  }

  if (props.compliancePolicyParam) {
    searchParams.set('compliancePolicy', props.compliancePolicyParam);
  }

  return searchParams.toString();
};
